import { render, staticRenderFns } from "./match-scan-header.vue?vue&type=template&id=2b7c4959"
import script from "./match-scan-header.vue?vue&type=script&lang=js"
export * from "./match-scan-header.vue?vue&type=script&lang=js"
import style0 from "./match-scan-header.vue?vue&type=style&index=0&id=2b7c4959&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports